export default __webpack_public_path__ + "static/assets/d470248cd235c3544220ea45c7148b28.png";